import * as React from 'react';
import styled from '../theme';
import Logo from '../components/LogoComponent'
interface IErrorProps {
    logo?: any;
    storyblokError: boolean;
    returnToRegistrationPage(): any;
}

class ErrorPage extends React.Component<IErrorProps> {
    constructor(props: IErrorProps) {
        super(props);

    }

    public render() {
        return (
            <MainWrapper>
                {this.props.logo ? <Logo logo={this.props.logo} /> : null}
                <Content>
                    {/* tslint:disable-next-line */}
                    <Icon id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.6 67.6"><title>error</title><path d="M40.87,63.62a2.79,2.79,0,0,1-2-.8,2.94,2.94,0,0,1-.7-1.9A2.73,2.73,0,0,1,39,59a2.78,2.78,0,0,1,3.8,0,2.73,2.73,0,0,1,.8,1.9,2.56,2.56,0,0,1-.8,1.9A2.36,2.36,0,0,1,40.87,63.62Zm0-11a2.69,2.69,0,0,1-2.7-2.7V35.72a2.7,2.7,0,0,1,5.4,0v14.2A2.69,2.69,0,0,1,40.87,52.62Zm0-38.1a33.8,33.8,0,1,0,33.8,33.8A33.8,33.8,0,0,0,40.87,14.52Z" transform="translate(-7.07 -14.52)" /></Icon>
                    <Title>{this.props.storyblokError ? 'Connection Error' : 'Registration Error'}</Title>
                    <Body>
                        {this.props.storyblokError ? 'There is an error with your connection. Please refresh to try again.' :
                            'There was an error with your registration. Please see the concierge for assistance.'}
                    </Body>
                </Content>
                <Button onClick={this.props.returnToRegistrationPage}>
                    {this.props.storyblokError ? 'Refresh' : 'Return home'}</Button>
            </MainWrapper>
        )
    }

}

export default ErrorPage

const MainWrapper = styled.div`
    width: 100%;
    min-height: 100%;
    padding: 6%;
    position: relative;
    box-sizing: border-box;
    background: -webkit-linear-gradient(
        ${(props: any) => props.theme.storyblokError ? '#f8f7f5' : props.theme.colors.backgroundDark2}, 
        ${(props: any) => props.theme.storyblokError ? '#f8f7f5' : props.theme.colors.backgroundDark3});
    background: linear-gradient(
        ${(props: any) => props.theme.storyblokError ? '#f8f7f5' : props.theme.colors.backgroundDark2}, 
        ${(props: any) => props.theme.storyblokError ? '#f8f7f5' : props.theme.colors.backgroundDark3});
`
const Content = styled.div`
    width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (max-width: 550px) {
        width: 100%;
        padding: 6%;
        box-sizing: border-box;
    }
`
const Icon = styled.svg`
    width: 3.125em;
    fill: ${(props: any) => props.theme.storyblokError ? '#ff0000' : props.theme.colors.backgroundHighlight};
    margin-bottom: 0.5em;

    @media (max-width: 550px) {
        margin-bottom: 1em;
    }
`
const Title = styled.h1`
    color: ${(props: any) => props.theme.storyblokError ? '#ff0000' : props.theme.colors.backgroundHighlight};
    text-align: center;
    font-weight: 400;
    text-transform: uppercase;
`
const Body = styled.p`
    font-size: 1.3em;
    text-align: center;
    color: ${(props: any) => props.theme.storyblokError ? '#000000' : props.theme.colors.bodyLight};
    margin: 3.125em 0;
    width: 80%;

    @media (max-width: 550px) {
        width: 100%;
        margin: 1em 0;
    }
`
const Button = styled.div`
    width: 85%;
    height: 60px;
    background:${(props: any) => props.theme.storyblokError ? '#ff0000' : props.theme.colors.backgroundHighlight};
    color: ${(props: any) => props.theme.storyblokError ? '#f8f7f5' : props.theme.colors.bodyHighlight};
    border: none;
    border-radius: 5px;
    font-weight: 800;
    font-size: 1.2em;
    text-align: center;
    line-height: 60px;
    position: absolute;
    bottom: 6%;
    left: 50%;
    transform: translateX(-50%);
`




// WEBPACK FOOTER //
// ./src/pages/ErrorPage.tsx